import { Inventory2 as Inventory2Icon } from '@frontierag/frontier-ui-library/icons';
import { APPLICATION_TYPES, PIM_URL } from 'appConstants';
import { useApp } from 'contexts/App';

import { cropMenuItems } from './cropMenuItems';
import { envCropsMenuItems } from './envCropsMenuItems';
import { fertMenuItems } from './fertMenuItems';
import { seedMenuItems } from './seedMenuItems';
import type { IHeaderMenuItem } from './types';

export default function useHeaderMenu() {
  const {
    state: { applicationType, userSettings },
  } = useApp();

  const { isAdmin = false } = userSettings || {};
  let menuItems: IHeaderMenuItem[] = [
    {
      icon: <Inventory2Icon />,
      label: 'Management',
      url: PIM_URL,
      shouldHideMenuItem: !isAdmin,
    },
  ];

  if (applicationType === APPLICATION_TYPES.FERTILISER) {
    menuItems = [...menuItems, ...fertMenuItems];
  }
  if (applicationType === APPLICATION_TYPES.CROP) {
    menuItems = [...menuItems, ...cropMenuItems];
  }
  if (applicationType === APPLICATION_TYPES.SEED) {
    menuItems = [...menuItems, ...seedMenuItems];
  }
  if (applicationType === APPLICATION_TYPES.ENVIRONMENTAL_CROPS) {
    menuItems = [...menuItems, ...envCropsMenuItems];
  }

  return {
    menuItems,
  };
}
